import React from 'react'
import MobileNavigation from './MobileNavigation'
import Navigation from './Navigation'
import classes from './NavBar.module.css'

const NavBar = () => {
    return (
        <div className={classes.NavBar}>
            <MobileNavigation/>
            <Navigation/>
        </div>
    )
}

export default NavBar